import { track } from '../analytics/events';

// const disallow = new Set(['vr', 'save']);

const trackButtonInteraction = async ({
  elementType, actionOutcome, text, alternativeType,
}) => track('ElementClicked', {
  webElement: {
    elementType: alternativeType ? alternativeType.toUpperCase() : elementType.toUpperCase(),
    text,
  },
  actionOutcome,
});
const trackClickInteraction = async ({
  elementType, checked, text, alternativeType, actionOutcome,
}) => track('ElementClicked', {
  webElement: {
    elementType: alternativeType ? alternativeType.toUpperCase() : elementType.toUpperCase(),
    text,
  },
  actionOutcome: actionOutcome ?? `TOGGLE_${checked ? 'ON' : 'OFF'}`,
});
const trackFieldInteraction = async ({
  fieldName, formName, value, elementType, pageName, text, alternativeType, alternativeValue,
}) => track('FieldInteracted', {
  userInputField: {
    fieldType: alternativeType ? alternativeType.toUpperCase() : elementType.toUpperCase(),
    fieldName,
    fieldLabel: text,
    fieldValue: alternativeValue ?? value,
  },
  formContext: {
    formName: formName ?? pageName,
  },
});
export default async function handleChoice({
  currentTarget: {
    type: elementType, checked, value, dataset: {
      alternativeType,
      text, mercurialName, eventName, formName, outcome: actionOutcome, pageName,
      alternativeValue,
    },
  },
}) {
  try {
    this[mercurialName] = !this[mercurialName];
    sessionStorage.setItem([mercurialName], this[mercurialName]);
  } catch (error) {
    //
  }
  switch (eventName) {
    default:
      return;
    case 'FieldInteracted':
      trackFieldInteraction({
        elementType,
        checked,
        value,
        text,
        mercurialName,
        formName,
        pageName,
        alternativeType,
        alternativeValue,
      });
      break;
    case 'ButtonClicked':
      trackButtonInteraction({
        elementType, checked, value, text, mercurialName, actionOutcome, alternativeType,
      });
      break;
    case 'ElementClicked':
      trackClickInteraction({
        elementType, checked, value, text, mercurialName, alternativeType, actionOutcome,
      });
      break;
  }
}
